import { Component, OnInit, OnChanges, Input, ViewChild, ElementRef, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-template',
    templateUrl: './template.component.html',
    styleUrls: ['./template.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule]
})
export class TemplateComponent implements OnInit, OnChanges {
  /// template ///
  @ViewChild('template', { static: false }) template: ElementRef<HTMLInputElement>;
  @Input() data: any = {
    html: '',
    form: {
      "template": ['']
    }
  };
  @Output() returnDataTemplate = new EventEmitter();
  formFields = [];
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {

    if (this.data.html !== '') {
      this.initTemplate(this.data);
    }

  }

  initTemplate(data) {

    const { form, fields, text } = data;

    const textParts = text.split(/({{[^}]+}})/);

    textParts.forEach(part => {
      if (part.startsWith('{{') && part.endsWith('}}')) {
        const fieldName = part.slice(2, -2).trim();
        const findValidator = fields.find(x => x.name === fieldName);
        let fi = {
          type: 'input',
          name: fieldName,
          placeholder: findValidator ? findValidator.placeholder : ''
        }
        this.formFields.push(fi);
      } else {
        this.formFields.push({ type: 'text', value: part });
      }
    });


    this.form = this.formBuilder.group(form);

    this.form.valueChanges.subscribe(value => {
      if (this.form.valid) {
        this.returnDataTemplate.emit(value);
      }
    })

  }

}
